// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3GFnL","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3vQSf"};